import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
export function ToolShell(t0) {
  const $ = _c(8);
  const {
    toolName,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="ml-2 rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-medium text-emerald-700">Free · No signup</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== toolName) {
    t2 = <div className="border-b border-slate-200 bg-slate-50 px-5 py-3"><p className="text-sm font-semibold text-slate-900">{toolName}{t1}</p></div>;
    $[1] = toolName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = <div className="space-y-4 p-5">{children}</div>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}